/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const periodStatsSchema = z.object({
	period_start: z.iso.date(),
	order_count: z.int(),
	total_sum: z.number(),
	avg_check: z.number(),
});
